"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackWorkflow = void 0;
var application_1 = require("../../models/application");
var mapping_1 = require("../../mapping");
var player_scroll_to_1 = require("player-scroll-to");
var UrlGetter_1 = require("../../shared/code/UrlGetter");
var api_1 = require("../../api");
var csod = require("player-core");
require("../../shared/SectionHeader.css");
require("../../shared/ApplicationWorkflow.css");
require("../../shared/MobileTypography.css");
var ApplicationActions_1 = require("../../actions/ApplicationActions");
var SpinnerController_1 = require("../../shared/code/SpinnerController");
var CookieHelper_1 = require("../../shared/code/CookieHelper");
var _ = require("lodash");
var UrlHelper_1 = require("../../shared/code/UrlHelper");
var tracker_defaults_1 = require("@csod/tracker-defaults");
var ApplicationWorkflowTracker_1 = require("../../shared/code/ApplicationWorkflowTracker");
csod.viewModel = {
    cultureID: 1,
    cultureName: 'en-US',
    getErrorMessage: '',
    validationErrorMessage: '',
    submissionErrorMessage: '',
    isCareerCenter: false,
    careerSiteId: 0,
    reqId: 0,
    applicationId: null,
    externalApplicationId: null,
    email: '',
    firstName: '',
    lastName: '',
    isLoading: false,
    displaySpinnerText: false,
    spinnerText: '',
    headerData: {
        isAdvanced: false,
        html: '',
        color: '',
        imagePath: '',
        imageAlt: '',
    },
    footerData: {
        isAdvanced: false,
        html: '',
        color: '',
        imagePath: '',
        imageAlt: '',
    },
    jobDetail: {
        displayTitle: '',
        primaryLocation: {
            title: '',
            geocode: {
                latitude: '',
                longitude: '',
            },
        },
        additionalLocations: [],
    },
    workflowPage: {
        currentPage: 0,
        totalPages: 0,
        isCareerSiteResponsive: false,
        actions: [],
    },
    resultData: Array(),
    resultDataLocalStorageKey: String,
    isPageDirty: Boolean,
    previousRoute: String,
    breakpoint: '',
    pageBackgroundColor: '',
    paddingSize: '',
    paddingSizeTwo: '',
    borderWidth: '',
    titlePadding: '',
    fileUploadWidth: '',
    submitCheckboxLabel: '',
    displayApplyWithErrorMessage: true,
    providerId: '',
    socialId: '',
    isResumeLoaded: false,
    createProfileURL: '',
    showProfileButton: false,
    DisclaimerIAgreeText: '',
    DisclaimerYesText: '',
    DisclaimerNoText: '',
    EEOShowLessText: '',
    EEOShowMoreText: '',
    AWTDialogTitleText: '',
    AWTDialogText: '',
    AWTSignInButtonText: '',
    AWTCancelText: '',
    TYThankYouText: '',
    TYsuccessText: '',
    TYcreateProfileText: '',
    TYbackToSearchText: '',
    IBcancelBtnText: '',
    IBbackBtnText: '',
    IBnextBtnText: '',
    IBsubmitBtnText: '',
    IBsaveBtnText: '',
    submitBtnDisabled: false,
    SPStepText: '',
    contactInformationSectionTitle: '',
    firstNameLabel: '',
    lastNameLabel: '',
    emailLabel: '',
    loginDialogTitle: '',
    signInButtonLabel: '',
    cancelButtonLabel: '',
    genericErrorMessage: '',
    applyWithAlreadyAssociated: '',
    applyWithExistingUser: '',
    applyWithGenericError: '',
    applyWithAuthenticationError: '',
    applyWithInactiveUserError: '',
    isEmailBeingValidated: false,
    dropdownOptionText: '',
    fileUploadText: '',
    fileUploadErrorMessage: '',
    deleteText: '',
    profileAddedText: '',
    parsingResumeText: '',
    coverLetterTitle: '',
    coverLetterUploadButtonText: '',
    coverLetterOrText: '',
    coverLettermanualEntryText: '',
    fileSizeErrorMessage: '',
    fileNameLengthErrorMessage: '',
    fileTypeErrorMessage: '',
    fileDeleteMessage: '',
    uploadDocumentText: '',
    applyWithButtonLabel: '',
    socialNetworkProfileUrl: '',
    socialMediaResumeData: null,
    applyWithSuccessNotification: '',
    applyWithErrorNotification: '',
    isPreview: false,
    previewWorkflowData: null,
    applyWithLinkedInData: {
        isEnabled: false,
        apiKey: '',
        integrationContext: '',
        didApplicantApplyWithLinkedIn: false,
        profileData: '',
    },
    searchQueryParameters: {},
    furthestPageVisited: 1,
    userId: -1,
    isICSReferralsOn: false,
    isIncreaseCharacterLengthForResumeFields: false,
    isTMNTApril2021Enabled: false,
    isAISkillsEnable: false
};
var apiServices = new api_1.ApiService();
var scrollToTop = function () {
    window.scrollTo(0, 0);
};
var mergeResumeActionItem = function (targetActionItem, sourceActionItem) {
    if (targetActionItem.parsingType != 0) {
        Object.keys(sourceActionItem.contactDetails).forEach(function (key) {
            targetActionItem.contactDetails[key].value = sourceActionItem.contactDetails[key].value;
        });
    }
    if (targetActionItem.parsingType === 2) {
        Object.keys(sourceActionItem.resumeStructure).forEach(function (key) {
            targetActionItem.resumeStructure[key] = sourceActionItem.resumeStructure[key];
        });
    }
    Object.keys(sourceActionItem.resumeFileUploadToken).forEach(function (key) {
        targetActionItem.resumeFileUploadToken[key] = sourceActionItem.resumeFileUploadToken[key];
    });
    targetActionItem.resumeSourceType = sourceActionItem.resumeSourceType;
};
var applicationWorkflowTracker = new ApplicationWorkflowTracker_1.ApplicationWorkflowTracker();
exports.trackWorkflow = function (eventName) {
    var hasSeenBPSQ = window.localStorage.getItem(ApplicationWorkflowTracker_1.ApplicationWorkflowEventTypes.doNotTrackSeenBPSQ) || false;
    applicationWorkflowTracker.trackApplicationWorkflow(eventName, hasSeenBPSQ, csod.viewModel.furthestPageVisited);
};
csod.pageDefinition = {
    mocks: {
        enabled: CookieHelper_1.CookieHelper.checkIsTrue('usemocks'),
        services: [],
        type: 'js',
        timeOut: 5000
    },
    locales: ["CareerSite", "UploadViewer"],
    initialize: function () {
        window.onerror = function (errorMsg) {
            var applicationJSError = {
                string: "Application Java Script Error",
                errorMessage: errorMsg
            };
            csod.logger.error(applicationJSError);
        };
        return new Promise(function (resolve, reject) {
            SpinnerController_1.SpinnerController.on(true);
            if (window.location.href.indexOf('/ui/') > -1) {
                csod.viewModel.isCareerCenter = true;
            }
            tracker_defaults_1.createStoreWithDefaults();
            csod.viewModel.searchQueryParameters = UrlHelper_1.UrlHelper.getQueryString();
            csod.viewModel.isPreview = !!csod.viewModel.searchQueryParameters["preview"];
            var cultureIdString = localStorage.getItem("RCECultureId");
            var cultureName = localStorage.getItem("RCECultureName");
            if (csod.context.user > 0 && cultureName !== csod.context.cultureName) {
                localStorage.setItem('RCECultureId', csod.context.cultureID.toString());
                localStorage.setItem('RCECultureName', csod.context.cultureName);
                cultureIdString = csod.context.cultureID.toString();
                cultureName = csod.context.cultureName;
            }
            csod.viewModel.cultureID = (cultureIdString != undefined) ? Number(cultureIdString) : csod.context.cultureID;
            csod.viewModel.cultureName = (cultureName != undefined) ? cultureName : csod.context.cultureName;
            window["csodAwliCallback"] = function (data) {
                if (data === {} && csod.viewModel.isTMNTApril2021Enabled) {
                    csod.notify.error(csod.viewModel.applyWithErrorNotification.replace('{0}', 'LinkedIn'));
                }
                else {
                    if (csod.viewModel.isTMNTApril2021Enabled)
                        csod.notify.success(csod.viewModel.applyWithSuccessNotification.replace('{0}', 'LinkedIn'));
                    if (csod.context.user < 1) {
                        var contactInfoResultData = csod.viewModel.resultData.find(function (r) { return r.type == 'contactInformation'; });
                        var contactInfoAction = csod.viewModel.workflowPage.actions.find(function (x) { return x.type == 'contactInformation'; });
                        contactInfoAction.email.value = contactInfoResultData.email = data.emailAddress;
                        contactInfoAction.firstName.value = contactInfoResultData.firstName = data.firstName;
                        contactInfoAction.lastName.value = contactInfoResultData.lastName = data.lastName;
                    }
                    csod.viewModel.applyWithLinkedInData.didApplicantApplyWithLinkedIn = true;
                    csod.viewModel.applyWithLinkedInData.profileData = data ? JSON.stringify(data) : '';
                    SpinnerController_1.SpinnerController.on(true);
                    var awliProviderId_1 = '4792074A-EB93-4C52-BC56-0AFB057FCCC5';
                    mapping_1.convertSocialNetworkData(awliProviderId_1, data)
                        .then(function (mappedData) {
                        var rAction = csod.viewModel.workflowPage.actions.find(function (x) { return x.type == 'resume'; });
                        var actionData = Object.assign(mappedData, {
                            resumeSourceType: 7,
                            resumeFileUploadToken: {
                                title: csod.viewModel.profileAddedText,
                                fileSize: 'LinkedIn',
                                fileIcon: '',
                                brandIcon: 'LinkedIn',
                                fileIconBackgroundColor: '',
                                fileUrl: data.publicProfileUrl,
                                deleteUrl: data.publicProfileUrl,
                            },
                        });
                        if (rAction) {
                            mergeResumeActionItem(rAction, actionData);
                        }
                        else {
                            csod.viewModel.socialMediaResumeData = actionData;
                        }
                        csod.viewModel.providerId = awliProviderId_1;
                        csod.viewModel.socialId = data.memberIdentifier;
                        SpinnerController_1.SpinnerController.off(true);
                    })
                        .catch(function (error) {
                        console.log('mapSocialNetworkData error: ' + JSON.stringify(error));
                        csod.notify.error(csod.viewModel.getErrorMessage);
                        SpinnerController_1.SpinnerController.off(true);
                    });
                }
            };
            csod.locales.setLocalesCulture(cultureName)
                .then(localize)
                .then(bootstrapServices)
                .then(getPageSize)
                .then(setPageStyle)
                .then(initializeApplyWithParams)
                .then(function () {
                if (csod.viewModel.externalApplicationId) {
                    return mapping_1.checkExternalJobApplicationCache(csod.viewModel.externalApplicationId)
                        .then(function (savedApplicationData) { return (savedApplicationData.applicationResultData.length > 0) ?
                        savedApplicationData :
                        mapping_1.getSavedApplication(csod.context.user, csod.viewModel.reqId); });
                }
                else {
                    return mapping_1.getSavedApplication(csod.context.user, csod.viewModel.reqId);
                }
            })
                .then(function (savedApplicationData) {
                if (!savedApplicationData.applicationResultData) {
                    var logEmptyExtApplicationId = {
                        string: "Request data set to null while pulling from saved applicant data on initialize",
                        extApplicationId: csod.viewModel.externalApplicantId
                    };
                    csod.logger.error(logEmptyExtApplicationId);
                }
                var cleanResultData = cleanLegacyISEPsqData(savedApplicationData.applicationResultData);
                csod.viewModel.resultDataLocalStorageKey = "awfResultData-" + csod.viewModel.reqId;
                if (window.sessionStorage.getItem(csod.viewModel.resultDataLocalStorageKey) != null) {
                    var _a = JSON.parse(window.sessionStorage.getItem(csod.viewModel.resultDataLocalStorageKey)), resultData = _a.resultData, currentPage = _a.currentPage;
                    if (resultData) {
                        setApplicationIdFromSavedIntegration(resultData);
                        if (csod.context.user > 0) {
                            _.remove(resultData, function (x) { return x.type === 'contactInformation'; });
                        }
                        csod.viewModel.resultData = resultData;
                    }
                    return currentPage;
                }
                csod.viewModel.resultData = cleanResultData;
                setApplicationIdFromSavedIntegration(savedApplicationData.applicationResultData);
                var tokens = getAttachedFileTokens();
                if (tokens.length > 0) {
                    apiServices.restoreWorkflowAttachments(tokens);
                }
                return savedApplicationData.page;
            })
                .then(function (pageNum) {
                pageNum = pageNum || 1;
                csod.viewModel.isPageDirty = true;
                csod.viewModel.previousRoute = pageNum;
                for (var i = 1; i <= pageNum; i++) {
                    createRouteForPage(i);
                }
                csod.routing.load(String(pageNum));
                resolve();
            });
        });
    },
    events: {
        onViewDataChanged: function (data) {
            var index = -1;
            for (var i = 0; i < csod.viewModel.resultData.length; i++) {
                var existingResultData = csod.viewModel.resultData[i];
                if (existingResultData.actionId === data.actionId) {
                    index = i;
                    break;
                }
            }
            if (index > -1) {
                csod.viewModel.resultData.splice(index, 1);
            }
            csod.viewModel.resultData.push(data);
            if (data.type === application_1.ActionType.contactInformation) {
                var contactInfoResultData = data;
                updateContactInfo(contactInfoResultData.firstName, contactInfoResultData.lastName, contactInfoResultData.email);
            }
            if (data.type === application_1.ActionType.resume) {
                var contactInfoResultData = data;
                csod.viewModel.contactDetails = contactInfoResultData.contactDetails;
            }
            return false;
        },
        onCancel: function () {
            var jobDetailsUrl = UrlGetter_1.UrlGetter.createJobDetailsUrl(csod.viewModel.workflowPage.isCareerSiteResponsive, csod.viewModel.reqId, csod.viewModel.careerSiteId, csod.viewModel.isCareerCenter, csod.viewModel.searchQueryParameters, csod.viewModel.cultureName);
            window.location.replace(jobDetailsUrl);
            window.sessionStorage.removeItem(csod.viewModel.resultDataLocalStorageKey);
            exports.trackWorkflow(ApplicationWorkflowTracker_1.ApplicationWorkflowEventTypes.cancel);
        },
        onSave: function () {
            saveProgress(csod.viewModel.resultData, csod.context.user, csod.viewModel.reqId, csod.viewModel.careerSiteId, csod.viewModel.workflowPage.currentPage);
        },
        onBackClick: function () {
            var backPageNum = csod.viewModel.workflowPage.currentPage - 1;
            csod.routing.load(String(backPageNum));
            exports.trackWorkflow(ApplicationWorkflowTracker_1.ApplicationWorkflowEventTypes.back);
        },
        onNextClick: function () {
            var hasRunNext = false;
            var nextInterval;
            if (csod.viewModel.isPreview || !csod.viewModel.isEmailBeingValidated) {
                nextClick();
            }
            else {
                nextInterval = setInterval(nextClick, 1000);
            }
            function nextClick() {
                if (csod.viewModel.isPreview || (!csod.viewModel.isEmailBeingValidated && !hasRunNext)) {
                    cleanErrors();
                    var isValid_1;
                    var pageNum = Number(csod.routing.current.path);
                    csod.viewModel.isLoading = true;
                    mapping_1.validateWorkflowPage(csod.viewModel.resultData, csod.viewModel.reqId, pageNum)
                        .then(function (data) {
                        isValid_1 = data.isValid;
                        if (isValid_1) {
                            exports.trackWorkflow(ApplicationWorkflowTracker_1.ApplicationWorkflowEventTypes.next);
                            csod.viewModel.isPageDirty = false;
                            csod.viewModel.previousRoute = csod.routing.current.path;
                            csod.viewModel.workflowPage.currentPage = csod.viewModel.workflowPage.currentPage + 1;
                            createRouteForPage(csod.viewModel.workflowPage.currentPage);
                            csod.routing.load(String(csod.viewModel.workflowPage.currentPage));
                        }
                        else {
                            validate(data.validatedActions);
                            csod.viewModel.isLoading = false;
                        }
                        csod.engine.commit();
                    })
                        .catch(function (error) {
                        console.log("validateWorkflowPage error: " + JSON.stringify(error));
                        csod.viewModel.isLoading = false;
                        csod.notify.error(csod.viewModel.validationErrorMessage);
                        csod.engine.commit();
                    });
                    hasRunNext = true;
                }
                else {
                    clearInterval(nextInterval);
                }
            }
        },
        onSubmit: function () {
            csod.viewModel.submitBtnDisabled = true;
            var hasRunSubmit = false;
            var submitInterval;
            if (csod.viewModel.isPreview || !csod.viewModel.isEmailBeingValidated) {
                submitClick();
            }
            else {
                submitInterval = setInterval(submitClick, 1000);
            }
            function submitClick() {
                if (csod.viewModel.isPreview || (!csod.viewModel.isEmailBeingValidated && !hasRunSubmit)) {
                    cleanErrors();
                    var pageNum = Number(csod.routing.current.path);
                    csod.viewModel.isLoading = true;
                    csod.viewModel.isPageDirty = false;
                    var qsParams_1 = csod.utils.parseQuery();
                    mapping_1.submitApplication(csod.viewModel.resultData, csod.viewModel.reqId, csod.viewModel.careerSiteId, csod.viewModel.isCareerCenter, csod.viewModel.applicationId, qsParams_1)
                        .then(function (response) {
                        if (response.isValid && response.isSuccessful) {
                            exports.trackWorkflow(ApplicationWorkflowTracker_1.ApplicationWorkflowEventTypes.submit);
                            Object.keys(csod.pageDefinition.routes).forEach(function (key) {
                                delete csod.pageDefinition.routes[key];
                            });
                            if (response.createProfileURL && response.createProfileURL.length) {
                                var backToSearchUrl = UrlGetter_1.UrlGetter.createBackToSearchUrl(csod.viewModel.workflowPage.isCareerSiteResponsive, csod.viewModel.reqId, csod.viewModel.careerSiteId, csod.viewModel.isCareerCenter, qsParams_1, csod.viewModel.cultureName);
                                backToSearchUrl = encodeURIComponent(backToSearchUrl);
                                csod.viewModel.createProfileURL = "" + csod.context.applicationBase + response.createProfileURL + "&site=" + csod.viewModel.careerSiteId + "&c=" + csod.context.corp + "&returnurl=" + backToSearchUrl + "&lang=" + csod.viewModel.cultureName;
                                csod.viewModel.showProfileButton = true;
                            }
                            var tokens = getAttachedFileTokens();
                            if (!!tokens && tokens.length > 0) {
                                apiServices.deleteAttachments(tokens);
                            }
                            scrollToTop();
                            csod.viewModel.userId = response.userId;
                            csod.viewModel.workflowPage.currentPage = csod.viewModel.workflowPage.currentPage + 1;
                            createRouteForPage(csod.viewModel.workflowPage.currentPage);
                            csod.routing.load(String(csod.viewModel.workflowPage.currentPage));
                        }
                        else {
                            if (!response.isSuccessful) {
                                csod.notify.error(response.errorMessage ? response.errorMessage : csod.viewModel.submissionErrorMessage);
                            }
                            if (!response.isValid) {
                                validate(response.validatedActions);
                            }
                            csod.viewModel.submitBtnDisabled = false;
                            csod.viewModel.isLoading = false;
                            csod.engine.commit();
                        }
                    })
                        .catch(function (error) {
                        console.log("submitApplication error: " + JSON.stringify(error));
                        SpinnerController_1.SpinnerController.off(true);
                        csod.notify.error(csod.viewModel.submissionErrorMessage);
                        csod.engine.commit();
                    });
                    hasRunSubmit = true;
                }
                else {
                    clearInterval(submitInterval);
                }
            }
        },
        onLoadingChanged: function (isLoading) {
            csod.viewModel.isLoading = isLoading;
            csod.viewModel.isVisible = isLoading;
        },
        onChangeSpinnerText: function (displaySpinnerText, spinnerText) {
            if (spinnerText === void 0) { spinnerText = ""; }
            csod.viewModel.displaySpinnerText = displaySpinnerText;
            csod.viewModel.spinnerText = spinnerText;
        },
        onBackToSearchClick: function () {
            console.log("Back to Search button click");
        },
        onCreateProfileClick: function () {
            console.log("Create Profile button click");
        },
        onBreakpoint: function (breakpoint) {
            csod.viewModel.breakpoint = breakpoint;
            setPageStyle();
        },
        onContactInfoLoaded: function () {
            csod.viewModel.displayApplyWithErrorMessage = false;
        },
        onResumeLoaded: function () {
            csod.viewModel.isResumeLoaded = true;
        },
        onApplicationIDChanged: function (jobApplicationId) {
            csod.viewModel.applicationId = jobApplicationId;
            window.sessionStorage.setItem(csod.viewModel.resultDataLocalStorageKey, JSON.stringify({
                resultData: csod.viewModel.resultData,
                currentPage: csod.viewModel.workflowPage.currentPage,
            }));
        }
    },
    routes: {}
};
var getAttachedFileTokens = function () {
    var tokens = new Array();
    for (var _i = 0, _a = csod.viewModel.resultData; _i < _a.length; _i++) {
        var result = _a[_i];
        var elementType = application_1.ActionType[result.type];
        if (elementType == application_1.ActionType.resume) {
            var resumeResult = result;
            if (resumeResult.resumeFileUploadToken) {
                tokens.push(resumeResult.resumeFileUploadToken);
            }
            if (resumeResult.coverLetterFileUploadToken) {
                tokens.push(resumeResult.coverLetterFileUploadToken);
            }
            for (var _b = 0, _c = resumeResult.additionalAttachmentsRequest; _b < _c.length; _b++) {
                var attachment = _c[_b];
                tokens.push(attachment.attachmentFileToken);
            }
        }
        else {
            continue;
        }
    }
    return tokens;
};
var saveProgress = function (resultData, userId, reqId, careersiteid, pageNum) {
    var successHandler = function () {
        csod.notify.success(csod.locales.get("ATS.Player.ResponsiveApplication.SaveSuccess", "Your application has been successfully saved."));
        var tokens = getAttachedFileTokens();
        if (tokens.length > 0) {
            apiServices.saveWorkflowAttachments(tokens);
        }
        SpinnerController_1.SpinnerController.off(true);
        exports.trackWorkflow(ApplicationWorkflowTracker_1.ApplicationWorkflowEventTypes.save);
    };
    var qsParams = csod.utils.parseQuery();
    var errorHandler = function () {
        csod.notify.error(csod.locales.get("ATS.Player.ResponsiveApplication.SaveFailure", "An error occurred while saving your application workflow. Please try again later or contact us."));
        SpinnerController_1.SpinnerController.off(true);
    };
    if (csod.context.user >= 1) {
        SpinnerController_1.SpinnerController.on();
        apiServices
            .saveApplication(resultData, userId, reqId, careersiteid, pageNum, qsParams)
            .then(successHandler)
            .catch(errorHandler);
    }
};
var prepopulatePrescreeningQuestions = function (action, result) {
    var questionMap = action.section.questions.reduce(function (map, question) {
        map[question.questionId.toString()] = question;
        return map;
    }, {});
    for (var _i = 0, _a = result.section.answers; _i < _a.length; _i++) {
        var answer = _a[_i];
        var questionKey = answer.questionId;
        var question = questionMap[questionKey];
        for (var _b = 0, _c = answer.responses; _b < _c.length; _b++) {
            var response = _c[_b];
            var optionMap = question.options.reduce(function (map, option) {
                map[option.responseId.toString()] = option;
                return map;
            }, {});
            var optionKey = response.responseId;
            var option = optionMap[optionKey];
            switch (question.type) {
                case "FreeFormEssay":
                case "ShortText":
                    option.value = response.textValue;
                    break;
                case "NumericValue":
                    option.value = response.numericValue.toString();
                    break;
                case "Date":
                    option.value = response.dateValue;
                    break;
                case "MultipleChoiceMultipleAnswer":
                case "MultipleChoiceSingleAnswer":
                case "YesNo":
                case "TrueFalse":
                    option.isChecked = true;
                    break;
            }
        }
    }
};
var prepopulteEEOQuestions = function (action, result) {
    for (var _i = 0, _a = result.answers; _i < _a.length; _i++) {
        var response = _a[_i];
        for (var _b = 0, _c = action.eeoQuestions; _b < _c.length; _b++) {
            var question = _c[_b];
            if (question.id == response.eeoQuestionId) {
                question.selectedResponse = response.eeoQuestionResponseId;
                if (question.followUpResponseId != undefined && question.followUpResponseId == response.eeoQuestionResponseId) {
                    question.displayFolloUpQuestion = true;
                }
                else {
                    question.displayFolloUpQuestion = false;
                }
            }
            else if (question.followUpEeoQuestion.id == response.eeoQuestionId) {
                question.followUpEeoQuestion.selectedResponse = response.eeoQuestionResponseId;
            }
        }
    }
};
var populateResumeAction = function (action, result) {
    action.contactDetails.addressLine1.value = result.contactDetails.addressLine1;
    action.contactDetails.addressLine2.value = result.contactDetails.addressLine2;
    action.contactDetails.city.value = result.contactDetails.city;
    action.contactDetails.state.value = result.contactDetails.state;
    action.contactDetails.zipCode.value = result.contactDetails.zipCode;
    action.contactDetails.country.value = result.contactDetails.countryCode;
    action.contactDetails.phone.value = {
        phoneNumber: result.contactDetails.phoneNumber,
        countryCode: result.contactDetails.phoneNumberCountryCode
    };
    action.contactDetails.isUserOptedInTextMessages.value = result.contactDetails.isUserOptedInTextMessages ? "true" : "false";
    action.resumeSourceType = result.resumeSourceType;
    action.resumeFileUploadToken.value = result.resumeFileUploadToken;
    if (result.resumeFileUploadToken) {
        action.resumeFileUploadToken.title = result.resumeFileUploadInfo.title;
        action.resumeFileUploadToken.fileSize = result.resumeFileUploadInfo.fileSize;
        action.resumeFileUploadToken.fileUrl = result.resumeFileUploadInfo.fileUrl;
        action.resumeFileUploadToken.deleteUrl = result.resumeFileUploadInfo.deleteUrl;
        action.resumeFileUploadToken.fileIcon = result.resumeFileUploadInfo.fileIcon;
        action.resumeFileUploadToken.fileIconBackgroundColor = result.resumeFileUploadInfo.fileIconBackgroundColor;
    }
    if (result.resumeSourceType === 7) {
        csod.viewModel.applyWithLinkedInData.profileData = result.socialNetworkProfileData;
        csod.viewModel.socialId = result.socialResume.socialId;
        csod.viewModel.providerId = result.socialResume.socialProviderId;
    }
    if (result.resumeStructure &&
        result.resumeStructure.sections &&
        result.resumeStructure.sections.length > 0) {
        var _loop_1 = function (section) {
            var sectionResult = result.resumeStructure.sections.find(function (s) { return s.sectionId == section.sectionId; });
            if (sectionResult != undefined) {
                section.entries = sectionResult.entries;
            }
        };
        for (var _i = 0, _a = action.resumeStructure.sections; _i < _a.length; _i++) {
            var section = _a[_i];
            _loop_1(section);
        }
    }
    action.aISkills = result && result.aISkills ? __spreadArrays(result.aISkills) : [];
    action.isAISkillsEnable = result && result.isAISkillsEnable;
    action.coverLetter.fileUploadToken.value = result.coverLetterFileUploadToken;
    if (result.coverLetterFileUploadToken) {
        action.coverLetter.fileUploadToken.title = result.coverLetterFileUploadInfo.title;
        action.coverLetter.fileUploadToken.fileSize = result.coverLetterFileUploadInfo.fileSize;
        action.coverLetter.fileUploadToken.fileUrl = result.coverLetterFileUploadInfo.fileUrl;
        action.coverLetter.fileUploadToken.deleteUrl = result.coverLetterFileUploadInfo.deleteUrl;
        action.coverLetter.fileUploadToken.fileIcon = result.coverLetterFileUploadInfo.fileIcon;
        action.coverLetter.fileUploadToken.fileIconBackgroundColor = result.coverLetterFileUploadInfo.fileIconBackgroundColor;
    }
    action.coverLetter.coverLetterText = result.coverLetterText;
    action.additionalAttachments.forEach(function (attachment) {
        result.additionalAttachmentsRequest
            .filter(function (a) { return a.attachmentId == attachment.attachmentId; })
            .forEach(function (attachmentResult, fileIdx) {
            var fileUpload;
            if (attachment.fileUploads[fileIdx]) {
                fileUpload = attachment.fileUploads[fileIdx];
            }
            else {
                fileUpload = attachment.addNewFileUpload();
            }
            fileUpload.token = Object.assign({}, attachmentResult.fileUploadInfo);
        });
    });
};
var populateCustomIntegrationAction = function (action, result) {
    action.launchURL = result.launchURL;
    action.integrationOrderId = result.integrationOrderId;
    action.applicationId = result.applicationId;
    csod.viewModel.applicationId = result.applicationId;
};
var prepopulateActions = function (actions, prePopulatedDataMap) {
    for (var _i = 0, actions_1 = actions; _i < actions_1.length; _i++) {
        var item = actions_1[_i];
        var elementType = application_1.ActionType[item.type];
        if (elementType === application_1.ActionType.note || elementType === application_1.ActionType.thankYou) {
            continue;
        }
        else if (elementType === application_1.ActionType.contactInformation) {
            var contactInfoAction = item;
            updateContactInfo(contactInfoAction.firstName.value, contactInfoAction.lastName.value, contactInfoAction.email.value);
        }
        var key = elementType.toString() + ":" + item.id;
        var matchingResult = prePopulatedDataMap[key];
        if (matchingResult == null) {
            continue;
        }
        switch (elementType) {
            case application_1.ActionType.contactInformation:
                {
                    var contactInfoAction = item;
                    var contactInfoResult = matchingResult;
                    contactInfoAction.firstName.value = contactInfoResult.firstName;
                    contactInfoAction.lastName.value = contactInfoResult.lastName;
                    contactInfoAction.email.value = contactInfoResult.email;
                    updateContactInfo(contactInfoAction.firstName.value, contactInfoAction.lastName.value, contactInfoAction.email.value);
                    csod.viewModel.applyWithLinkedInData.didApplicantApplyWithLinkedIn = contactInfoResult.appliedWithLinkedIn;
                }
                break;
            case application_1.ActionType.interviewIntegration:
                {
                    var preferredCommunicationAction = item;
                    var preferredCommunicationResult = matchingResult;
                    preferredCommunicationAction.preferredCommunicationOptions.value = preferredCommunicationResult.preferredMethodOfCommunication;
                }
                break;
            case application_1.ActionType.disclaimer:
                {
                    item.isAgreed = matchingResult.isAgreed;
                }
                break;
            case application_1.ActionType.prescreeningQuestions:
                {
                    var psqAction = item;
                    var psqResult = matchingResult;
                    prepopulatePrescreeningQuestions(psqAction, psqResult);
                }
                break;
            case application_1.ActionType.submit:
                {
                    item.isUserOptedIn = matchingResult.isUserOptedIn;
                }
                break;
            case application_1.ActionType.eeoQuestions:
                {
                    var eeoAction = item;
                    var eeoResult = matchingResult;
                    prepopulteEEOQuestions(eeoAction, eeoResult);
                }
                break;
            case application_1.ActionType.resume:
                {
                    var resumeAction = item;
                    var resumeResult = matchingResult;
                    populateResumeAction(resumeAction, resumeResult);
                }
                break;
            case application_1.ActionType.customIntegration:
                {
                    var customIntegrationAction = item;
                    var customIntegrationResult = matchingResult;
                    populateCustomIntegrationAction(customIntegrationAction, customIntegrationResult);
                }
                break;
        }
    }
};
var focusOnPageStart = function () {
    if (window['Cypress'] || window.Cypress) {
        return;
    }
    setTimeout(function () {
        var stepContainer = document.querySelector('[role="main"]') ||
            document.querySelector('main') ||
            document.querySelector('[data-step]') ||
            document.querySelector('[data-page]') ||
            document.querySelector('.p-gridlayout .p-gridcol > div:first-child') ||
            document.querySelector('.p-panel:has(input, select, textarea)') ||
            document.body;
        if (stepContainer) {
            stepContainer.setAttribute('tabindex', '-1');
            stepContainer.focus();
            setTimeout(function () {
                stepContainer.removeAttribute('tabindex');
            }, 100);
        }
    }, 100);
};
var createRouteForPage = function (pageNum) {
    if (csod.pageDefinition.routes[String(pageNum)] == undefined) {
        csod.pageDefinition.routes[String(pageNum)] =
            {
                load: function (options) {
                    var newPageNumber = Number(csod.routing.current.path);
                    var previousPageNumber = Number(csod.viewModel.previousRoute);
                    var isGoingForward = newPageNumber > previousPageNumber;
                    if (isGoingForward && csod.viewModel.isPageDirty) {
                        csod.routing.load(csod.viewModel.previousRoute);
                    }
                    else {
                        var providerId = "";
                        var socialId = "";
                        if (!csod.viewModel.isResumeLoaded) {
                            providerId = csod.viewModel.providerId;
                            socialId = csod.viewModel.socialId;
                        }
                        csod.viewModel.isLoading = true;
                        var processWorkflowPage = function (workflowPageData) {
                            if (workflowPageData.errorResponse.redirectUrl) {
                                window.location.replace("" + csod.context.applicationBase + workflowPageData.errorResponse.redirectUrl);
                                return;
                            }
                            var resultDataLocalStorageKey = csod.viewModel.resultDataLocalStorageKey;
                            scrollToTop();
                            csod.viewModel.isLoading = false;
                            var userSessionInfo = csod.viewModel.resultData.reduce(function (map, obj) {
                                map[obj.type.toString() + ":" + obj.actionId] = obj;
                                return map;
                            }, {});
                            prepopulateActions(workflowPageData.actions, userSessionInfo);
                            if (csod.viewModel.socialMediaResumeData && workflowPageData.actions.findIndex(function (x) { return x.type === 'resume'; }) != -1) {
                                var action = workflowPageData.actions.find(function (x) { return x.type === 'resume'; });
                                mergeResumeActionItem(action, csod.viewModel.socialMediaResumeData);
                                csod.viewModel.socialMediaResumeData = null;
                            }
                            if (workflowPageData.applicationId && workflowPageData.applicationId > 0) {
                                csod.viewModel.applicationId = workflowPageData.applicationId;
                            }
                            csod.viewModel.workflowPage = workflowPageData;
                            csod.engine.commit();
                            focusOnPageStart();
                            if (window.sessionStorage.getItem(resultDataLocalStorageKey) != null) {
                                var locallyStoredApplicationData = JSON.parse(window.sessionStorage.getItem(resultDataLocalStorageKey));
                                if (locallyStoredApplicationData.hasOwnProperty('saveOnReload')) {
                                    saveProgress(csod.viewModel.resultData, csod.context.user, csod.viewModel.reqId, csod.viewModel.careerSiteId, csod.viewModel.workflowPage.currentPage);
                                }
                                window.sessionStorage.removeItem(resultDataLocalStorageKey);
                            }
                            csod.viewModel.isPageDirty = true;
                            csod.viewModel.previousRoute = csod.routing.current.path;
                        };
                        var triggerAmplitudeEvent = function () {
                            ApplicationWorkflowTracker_1.ApplicationWorkflowEventTypes.doNotTrackSeenBPSQ = "DoNotTrackBPSQ-" + csod.viewModel.reqId;
                            if (csod.viewModel.workflowPage.currentPage > csod.viewModel.furthestPageVisited) {
                                csod.viewModel.furthestPageVisited = csod.viewModel.workflowPage.currentPage;
                            }
                            var doNotTrackApplicationStart = "DoNotTrack-" + csod.viewModel.reqId;
                            if (window.localStorage.getItem(doNotTrackApplicationStart) == null) {
                                exports.trackWorkflow(ApplicationWorkflowTracker_1.ApplicationWorkflowEventTypes.start);
                            }
                            window.localStorage.setItem(doNotTrackApplicationStart, "true");
                        };
                        var handleErrors = function () {
                            csod.viewModel.isLoading = false;
                            csod.notify.error(csod.viewModel.getErrorMessage);
                            csod.engine.commit();
                        };
                        if (csod.viewModel.isCareerCenter) {
                            mapping_1.getCareerCenterApplicationWorkflowPage(csod.viewModel.reqId, pageNum)
                                .then(processWorkflowPage)
                                .then(triggerAmplitudeEvent)
                                .catch(handleErrors);
                        }
                        else {
                            mapping_1.getApplicationWorkflowPage(csod.viewModel.reqId, pageNum, csod.viewModel.careerSiteId, providerId, socialId)
                                .then(processWorkflowPage)
                                .then(triggerAmplitudeEvent)
                                .catch(handleErrors);
                        }
                    }
                },
                unload: function () {
                }
            };
    }
};
var cleanErrors = function () {
    for (var _i = 0, _a = csod.viewModel.workflowPage.actions; _i < _a.length; _i++) {
        var action = _a[_i];
        var elementType = application_1.ActionType[action.type];
        if (elementType === application_1.ActionType.prescreeningQuestions) {
            action.section.questions.forEach(function (q) {
                q.errorMessage = "";
            });
            break;
        }
    }
};
var validate = function (validatedActions) {
    validatedActions.forEach(function (validatedAction) {
        if (validatedAction.isValid == false) {
            switch (validatedAction.type) {
                case application_1.ActionType.contactInformation:
                    validateContactInfo(validatedAction);
                    break;
                case application_1.ActionType.interviewIntegration:
                    validatePreferredCommunication(validatedAction);
                    break;
                case application_1.ActionType.disclaimer:
                    validateDisclaimer(validatedAction);
                    break;
                case application_1.ActionType.eeoQuestions:
                    validateEEOQuestions(validatedAction);
                    break;
                case application_1.ActionType.prescreeningQuestions:
                    validatePrescreeningQuestions(validatedAction);
                    break;
                case application_1.ActionType.resume:
                    validateResume(validatedAction);
                    break;
                case application_1.ActionType.customIntegration:
                    validateCustomIntegration(validatedAction);
                    break;
            }
        }
    });
    csod.engine.commit();
    scrollToError();
};
var validateContactInfo = function (validatedContactInfo) {
    var validation = validatedContactInfo;
    var contactInfoAction;
    for (var _i = 0, _a = csod.viewModel.workflowPage.actions; _i < _a.length; _i++) {
        var action = _a[_i];
        if (action.id == validation.actionId) {
            contactInfoAction = action;
            break;
        }
    }
    for (var _b = 0, _c = validation.errors; _b < _c.length; _b++) {
        var error = _c[_b];
        var property = getObjectFromPath(contactInfoAction, error.path);
        if (property != undefined) {
            property.errorMessage = error.message;
        }
    }
};
var validatePreferredCommunication = function (validatedPreferredCommunication) {
    var validation = validatedPreferredCommunication;
    for (var _i = 0, _a = csod.viewModel.workflowPage.actions; _i < _a.length; _i++) {
        var action = _a[_i];
        if (action.id === validatedPreferredCommunication.actionId) {
            action.preferredCommunicationOptions.errorMessage = validation.errors[0].message;
            break;
        }
    }
};
var validateResume = function (validatedResume) {
    var validation = validatedResume;
    var resumeAction;
    for (var _i = 0, _a = csod.viewModel.workflowPage.actions; _i < _a.length; _i++) {
        var action = _a[_i];
        if (action.id == validation.actionId) {
            resumeAction = action;
            break;
        }
    }
    for (var _b = 0, _c = validation.errors; _b < _c.length; _b++) {
        var error = _c[_b];
        var property = getObjectFromPath(resumeAction, error.path);
        if (property != undefined) {
            property.errorMessage = error.message;
        }
    }
};
var validateEEOQuestions = function (validatedEEOQuestions) {
    var validation = validatedEEOQuestions;
    var eeoAction;
    for (var _i = 0, _a = csod.viewModel.workflowPage.actions; _i < _a.length; _i++) {
        var action = _a[_i];
        if (action.id == validation.actionId) {
            eeoAction = action;
            break;
        }
    }
    var eeoResult;
    for (var _b = 0, _c = csod.viewModel.resultData; _b < _c.length; _b++) {
        var result = _c[_b];
        if (result.actionId == validation.actionId) {
            eeoResult = result;
            break;
        }
    }
    for (var _d = 0, _e = validation.errors; _d < _e.length; _d++) {
        var error = _e[_d];
        var questionIndexIndex = error.path.lastIndexOf("/") + 1;
        var questionIdIndexInPath = Number(error.path.substr(questionIndexIndex));
        var invalidQuestionId = eeoResult.answers[questionIdIndexInPath].eeoQuestionId;
        for (var _f = 0, _g = eeoAction.eeoQuestions; _f < _g.length; _f++) {
            var question = _g[_f];
            if (question.id == invalidQuestionId) {
                question.errorMessage = error.message;
                break;
            }
            else if (question.followUpEeoQuestion.id == invalidQuestionId) {
                question.followUpEeoQuestion.errorMessage = error.message;
                break;
            }
        }
    }
};
var validateDisclaimer = function (validatedDisclaimer) {
    var validation = validatedDisclaimer;
    var invalidDislcaimer;
    for (var _i = 0, _a = csod.viewModel.workflowPage.actions; _i < _a.length; _i++) {
        var action = _a[_i];
        if (action.id === validatedDisclaimer.actionId) {
            action.errorMessage = validation.errorMessage;
            break;
        }
    }
};
var validatePrescreeningQuestions = function (validatedPrescreeningSection) {
    var validation = validatedPrescreeningSection;
    var errors = validation.errors.reduce(function (acc, error) {
        acc[error.questionId] = error.errorMessage;
        return acc;
    }, {});
    for (var _i = 0, _a = csod.viewModel.workflowPage.actions; _i < _a.length; _i++) {
        var action = _a[_i];
        if (action.id === validatedPrescreeningSection.actionId) {
            action.section.questions.forEach(function (q) {
                q.errorMessage = errors[q.questionId];
            });
            break;
        }
    }
};
var cleanLegacyISEPsqData = function (applicationResultData) {
    var cleanResultData = [];
    for (var _i = 0, applicationResultData_1 = applicationResultData; _i < applicationResultData_1.length; _i++) {
        var result = applicationResultData_1[_i];
        if (!(result.type == application_1.ActionType.prescreeningQuestions && result.section.iseSectionGuid)) {
            cleanResultData.push(result);
        }
    }
    return cleanResultData;
};
var setApplicationIdFromSavedIntegration = function (applicationResultData) {
    var savedIntegration = applicationResultData.find(function (s) { return s.type == application_1.ActionType.customIntegration && s.applicationId; });
    if (savedIntegration) {
        csod.viewModel.applicationId = savedIntegration.applicationId;
    }
};
var validateCustomIntegration = function (validatedCustomIntegrationAction) {
    var validation = validatedCustomIntegrationAction;
    for (var _i = 0, _a = csod.viewModel.workflowPage.actions; _i < _a.length; _i++) {
        var action = _a[_i];
        if (action.id === validatedCustomIntegrationAction.actionId) {
            action.errorMessage = validation.errorMessage;
            break;
        }
    }
};
var getObjectFromPath = function (actionItem, path) {
    var properties = path.split('/').filter(Boolean);
    var obj = actionItem;
    for (var _i = 0, properties_1 = properties; _i < properties_1.length; _i++) {
        var index = properties_1[_i];
        if (typeof obj == "undefined") {
            return undefined;
        }
        obj = obj[index];
    }
    return obj;
};
var localize = function () {
    csod.viewModel.submitCheckboxLabel = csod.locales.get("ATS.CandidateSearch.OptIn", "Consider me for other positions and allow my information to be searchable.");
    csod.viewModel.getErrorMessage = csod.locales.get("ATS.Player.ResponsiveApplication.Error", "An error occurred, please try again. If the error persists please contact us.");
    csod.viewModel.validationErrorMessage = csod.locales.get("ATS.Player.ResponsiveApplication.ValidationError", "A validation error occurred, please try again. If the error persists please contact us.");
    csod.viewModel.submissionErrorMessage = csod.locales.get("ATS.Player.ResponsiveApplication.SubmissionError", "A submission error occurred, please try again. If the error persists please contact us.");
    csod.viewModel.DisclaimerIAgreeText = csod.locales.get("I Agree", "I agree");
    csod.viewModel.DisclaimerYesText = csod.locales.get("Yes", "Yes");
    csod.viewModel.DisclaimerNoText = csod.locales.get("No", "No");
    csod.viewModel.EEOShowLessText = csod.locales.get("Show Less", "Show Less");
    csod.viewModel.EEOShowMoreText = csod.locales.get("Show More", "Show More");
    csod.viewModel.AWTDialogTitleText = csod.locales.get("Sign In", "Sign In");
    csod.viewModel.AWTDialogText = csod.locales.get("ATS.Player.ResponsiveApplication.PromptToLoginToSave", "To save your progress, you must be logged in. This will also allow you to see the status of your application.");
    csod.viewModel.AWTSignInButtonText = csod.locales.get("ATS.Player.ResponsiveApplication.LinkToLoginOrRegister", "Log In or Create Account");
    csod.viewModel.AWTCancelText = csod.locales.get("Cancel", "Cancel");
    csod.viewModel.TYThankYouText = csod.locales.get("Thank You!", "Thank You!");
    csod.viewModel.TYsuccessText = csod.locales.get("SuccessfullyApplied", "You have successfully applied to") + " ";
    csod.viewModel.TYcreateProfileText = csod.locales.get("Create Profile", "Create Profile");
    csod.viewModel.TYbackToSearchText = csod.locales.get("Back to Search", "Back to Search");
    csod.viewModel.IBcancelBtnText = csod.locales.get("Cancel", "Cancel"),
        csod.viewModel.IBbackBtnText = csod.locales.get("Back", "Back"),
        csod.viewModel.IBnextBtnText = csod.locales.get("Next", "Next"),
        csod.viewModel.IBsubmitBtnText = csod.locales.get("Submit", "Submit"),
        csod.viewModel.IBsaveBtnText = csod.locales.get("Save", "Save");
    csod.viewModel.SPStepText = csod.locales.get("Step {0} of {1}", "Page {0} of {1}");
    csod.viewModel.contactInformationSectionTitle = csod.locales.get("Contact Information", "Contact Information");
    csod.viewModel.firstNameLabel = csod.locales.get("First Name", "First Name");
    csod.viewModel.lastNameLabel = csod.locales.get("Last Name", "Last Name");
    csod.viewModel.emailLabel = csod.locales.get("Email", "Email");
    csod.viewModel.loginDialogTitle = csod.locales.get("Existing account login prompt.", "Existing account login prompt.");
    csod.viewModel.signInButtonLabel = csod.locales.get("Sign In", "Sign In");
    csod.viewModel.cancelButtonLabel = csod.locales.get("Cancel", "Cancel");
    csod.viewModel.genericErrorMessage = csod.locales.get("ATS.Player.ResponsiveApplication.Error", "An error occurred, please try again. If the error persists please contact us.");
    csod.viewModel.applyWithAlreadyAssociated = csod.locales.get("ATS.CareerSite.ApplyWithIntegration.Warning.AlreadyAssociated");
    csod.viewModel.applyWithExistingUser = csod.locales.get("ATS.CareerSite.ApplyWithIntegration.Warning.ExistingUser");
    csod.viewModel.applyWithGenericError = csod.locales.get("ATS.CareerSite.ApplyWithIntegration.Warning.GenericError");
    csod.viewModel.applyWithAuthenticationError = csod.locales.get("ATS.CareerSite.ApplyWithIntegration.Warning.AuthenticationError");
    csod.viewModel.applyWithInactiveUserError = csod.locales.get("ATS.CareerSite.ApplyWithIntegration.Warning.InactiveUserError");
    csod.viewModel.dropdownOptionText = csod.locales.get("Please Select", "Please Select");
    csod.viewModel.fileUploadText = csod.locales.get("Upload Resume/CV", "Upload Resume/CV");
    csod.viewModel.fileUploadErrorMessage = csod.locales.get("* An error occurred while uploading the file.", "* An error occurred while uploading the file.");
    csod.viewModel.profileAddedText = csod.locales.get("Profile Added:", "Profile Added:");
    csod.viewModel.parsingResumeText = csod.locales.get("Processing Resume/CV. This could take several seconds.", "Processing Resume/CV. This could take several seconds.");
    csod.viewModel.addAdditionalAttachmentText = csod.locales.get("Add Additional Attachment", "Add Additional Attachment");
    csod.viewModel.coverLetterTitle = csod.locales.get("Cover Letter", "Cover Letter");
    csod.viewModel.coverLetterUploadButtonText = csod.locales.get("Upload Cover Letter", "Upload Cover Letter");
    csod.viewModel.coverLetterOrText = csod.locales.get("Or", "or");
    csod.viewModel.coverLettermanualEntryText = csod.locales.get("TypeManually", "Type it manually");
    csod.viewModel.fileSizeErrorMessage = csod.locales.get('* File cannot be greater than {0} in size.', '* File cannot be greater than {0} in size.');
    csod.viewModel.fileNameLengthErrorMessage = csod.locales.get('* File name cannot exceed {0} characters.', '* File name cannot exceed {0} characters.');
    csod.viewModel.fileTypeErrorMessage = csod.locales.get('* File must be of type {0}.', '* File must be of type {0}.');
    csod.viewModel.fileDeleteMessage = csod.locales.get('Delete File', 'Delete File');
    csod.viewModel.uploadDocumentText = csod.locales.get('Upload Document', 'Upload Document');
    csod.viewModel.applyWithButtonLabel = csod.locales.get("Apply with {0}", "Apply with {0}");
    csod.viewModel.applyWithSuccessNotification = csod.locales.get('ATS.AppWorkflow.ApplyWith.SuccessNotification', '{0} information loaded successfully.');
    csod.viewModel.applyWithErrorNotification = csod.locales.get('ATS.AppWorkflow.ApplyWith.ErrorNotification', 'Failed to retrieve {0} information.');
    csod.engine.commit();
};
var bootstrapServices = function () {
    var l = window.location.href.split("/");
    fetchIncreaseCharacterLengthForResumeFieldsCorpSetting();
    if (csod.viewModel.isCareerCenter) {
        csod.viewModel.reqId = l[l.length - 1].split("?")[0];
        return mapping_1.bootstrapCareerCenterApplication(csod.viewModel.reqId, csod.viewModel.cultureID.toString()).then(populate);
    }
    else {
        for (var i = 0; i < l.length; i++) {
            if (l[i] == "careersite")
                csod.viewModel.careerSiteId = l[i + 1];
            if (l[i] == "requisition")
                csod.viewModel.reqId = l[i + 1];
        }
        fetchICSReferralsCorpSetting();
        fetchTMNTApril2021ReleaseCorpSetting();
        return mapping_1.bootstrapCareerSiteApplication(csod.viewModel.careerSiteId, csod.viewModel.reqId, csod.viewModel.cultureID.toString()).then(populate);
    }
};
var fetchICSReferralsCorpSetting = function () {
    return mapping_1.getCorpSettingValue("ICSReferrals").then(function (data) {
        csod.viewModel.isICSReferralsOn = data;
    });
};
var fetchTMNTApril2021ReleaseCorpSetting = function () {
    return mapping_1.getCorpSettingValue('NinjaTurtlesMinorEnhancementsApril2021').then(function (data) {
        csod.viewModel.isTMNTApril2021Enabled = (data.toString() === 'true') ? true : false;
    });
};
var fetchIncreaseCharacterLengthForResumeFieldsCorpSetting = function () {
    return mapping_1.getCorpSettingValue('IncreaseCharacterLengthForResumeFields').then(function (data) {
        csod.viewModel.isIncreaseCharacterLengthForResumeFields = (data.toString() === 'true') ? true : false;
    });
};
var populate = function () {
    if (!csod.viewModel.isCareerCenter) {
        mapping_1.getSiteData().then(function (data) {
            csod.viewModel.headerData = Object.assign(csod.viewModel.headerData, data.header);
            csod.viewModel.footerData = Object.assign(csod.viewModel.footerData, data.footer);
            document.documentElement.dir = (data.settings.currentLanguage.isRightToLeft) ? "rtl" : "ltr";
        });
    }
    mapping_1.getJobDetail().then(function (data) {
        csod.viewModel.jobDetail = Object.assign(csod.viewModel.jobDetail, data);
    });
    csod.engine.commit();
};
var getPageSize = function () {
    var width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    var breakpoints = {
        'xs': 480,
        'sm': 600,
        'md': 840,
        'lg': 960,
        'xl': 1280
    };
    if (width >= 0 && width < breakpoints.xs) {
        csod.viewModel.breakpoint = 'Min';
    }
    else if (width >= breakpoints.xs && width < breakpoints.sm) {
        csod.viewModel.breakpoint = 'Xs';
    }
    else if (width >= breakpoints.sm && width < breakpoints.md) {
        csod.viewModel.breakpoint = 'Sm';
    }
    else if (width >= breakpoints.md && width < breakpoints.lg) {
        csod.viewModel.breakpoint = 'Md';
    }
    else if (width >= breakpoints.lg && width < breakpoints.xl) {
        csod.viewModel.breakpoint = 'Lg';
    }
    else if (width >= breakpoints.xl) {
        csod.viewModel.breakpoint = 'Xl';
    }
};
var setPageStyle = function () {
    switch (csod.viewModel.breakpoint) {
        case 'Xs':
            csod.viewModel.pageBackgroundColor = "White";
            csod.viewModel.paddingSize = "Medium";
            csod.viewModel.paddingSizeTwo = "None";
            csod.viewModel.borderWidth = "Zero";
            csod.viewModel.fileUploadWidth = "Block";
            csod.viewModel.titlePadding = "Medium";
            break;
        case 'Sm':
            csod.viewModel.pageBackgroundColor = "Grey80";
            csod.viewModel.paddingSize = "Xlarge";
            csod.viewModel.paddingSizeTwo = "None";
            csod.viewModel.borderWidth = "Xsmall";
            csod.viewModel.fileUploadWidth = "Block";
            csod.viewModel.titlePadding = "None";
            break;
        case 'Md':
            csod.viewModel.pageBackgroundColor = "Grey80";
            csod.viewModel.paddingSize = "Xlarge";
            csod.viewModel.paddingSizeTwo = "None";
            csod.viewModel.borderWidth = "Xsmall";
            csod.viewModel.fileUploadWidth = "Block";
            csod.viewModel.titlePadding = "None";
            break;
        case 'Lg':
            csod.viewModel.pageBackgroundColor = "Grey80";
            csod.viewModel.paddingSize = "Xlarge";
            csod.viewModel.paddingSizeTwo = "Xlarge";
            csod.viewModel.borderWidth = "Xsmall";
            csod.viewModel.fileUploadWidth = "Block";
            csod.viewModel.titlePadding = "None";
            break;
        case 'Xl':
            csod.viewModel.pageBackgroundColor = "Grey80";
            csod.viewModel.paddingSize = "Xlarge";
            csod.viewModel.paddingSizeTwo = "Xlarge";
            csod.viewModel.borderWidth = "Xsmall";
            csod.viewModel.fileUploadWidth = "Block";
            csod.viewModel.titlePadding = "None";
            break;
        default:
            csod.viewModel.pageBackgroundColor = "White";
            csod.viewModel.paddingSize = "Medium";
            csod.viewModel.paddingSizeTwo = "None";
            csod.viewModel.borderWidth = "Zero";
            csod.viewModel.fileUploadWidth = "Block";
            csod.viewModel.titlePadding = "Medium";
            break;
    }
};
var initializeApplyWithParams = function () {
    var qsParams = ApplicationActions_1.getParams(window.location.search);
    if (qsParams["provider"]) {
        csod.viewModel.providerId = qsParams["provider"];
    }
    if (qsParams["socialId"]) {
        csod.viewModel.socialId = qsParams["socialId"];
    }
    if (qsParams["externalApplicationId"]) {
        csod.viewModel.externalApplicationId = qsParams["externalApplicationId"];
    }
};
var updateContactInfo = function (firstName, lastName, email) {
    csod.viewModel.firstName = firstName;
    csod.viewModel.lastName = lastName;
    csod.viewModel.email = email;
};
var scrollToError = function () {
    var errorEl = document.querySelector('.is-invalid, [data-tag="psq-error"]');
    if (errorEl) {
        var input_1 = errorEl.getElementsByTagName('input');
        var select_1 = errorEl.getElementsByTagName('select');
        var button_1 = errorEl.getElementsByTagName('button');
        player_scroll_to_1.smoothScroll({ left: 0, top: player_scroll_to_1.getOffset(errorEl).top });
        var timer = setTimeout(function () {
            if (button_1.length) {
                button_1[0].focus();
            }
            else if (select_1.length) {
                select_1[0].focus();
            }
            else if (input_1.length) {
                input_1[0].focus();
            }
        }, 300);
    }
};



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/pages/application/page.ts
// module id = 637
// module chunks = 0